// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2YUIv","signatureBlock":"Footer_signatureBlock__3pLys","signature":"Footer_signature__3KRI1"};